import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Box } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import { useContext } from 'react';
import GoodsDetailCollapse from './GoodsDetailCollapse';
import ProductParams, { ProductParamsProps } from './ProductParams';

export default function ProductDetails(props: ProductParamsProps) {
  const { deviceType } = useContext(ResponsiveContext);
  const t = useTranslations('goodsDetail.productDetails');

  return (
    <GoodsDetailCollapse
      title={t('title')}
      defaultOpen
      onChange={() => props.SDProductDetailsPageBtnClick?.('Product Details')}
    >
      <Box className={`mb-24 ${deviceType === EPlatform.WEB ? 'mb-24' : 'mb-20'}`}>
        <ProductParams {...props} />
      </Box>
    </GoodsDetailCollapse>
  );
}
